import React from 'react';
// TODO
import { Button, Divider, Spin } from 'antd';
import './index.less';
import Empty from '@/components/core-empty';
import { useRecommendActivityList, delayExecFunc, renderActivityNameAndTag, renderOpenSeckillSkuInfo } from '../config';
import activityApis from '@/pages/system/applicationmanage/pages/bannerManage/apis';
import { goto } from '@/common/goto';
import { useDripSource } from '@/apis/dripDataSource';

// TODO
const prefixCls = 'high-traffic-activity';

const HighTrafficActivity = ({ menuOrder, mode }) => {
  const { recommendActivityList, loading } = useRecommendActivityList(menuOrder);

  // drip数据源
  const [getDripSource] = useDripSource();
  const isGoNewRoomList = getDripSource('useNewOpenApplyVersionInErp', '0') == '1';

  const gotoMcActivityDetail = (activityId) => {
    logUpload(activityId);
    window.open(
      `/activity-manage/myCreate/pools/roomlist?entry=1&activityId=${activityId}&from=acore&hideTab=1&id=${activityId}`
    );
  };
  const gotoUMActivityDetail = (activityId) => {
    logUpload(activityId);
    window.open(
      `/activity-manage/myCreate/zongcuActivity/myJoin/detail/activityEnroll/detail?activity_id=${activityId}`
    );
  };
  function logUpload(activityId) {
    log && log('yx_center', 'recommendsignup', `{"activityid":"${activityId}"}`);
  }

  // 会场日常活动、资源位非开放报名、
  const renderMcActivityItem = (activityInfo) => {
    const { activityId } = activityInfo;

    return (
      // 京麦10暂时保留单列展示
      <div className={`${prefixCls}-item ${mode}}`}>
        <div className={`${prefixCls}-item-content-left`}>
          <div className="img-wrapper">
            <img
              src="https://img14.360buyimg.com/img/jfs/t1/98103/32/38106/2739/6556cfacF8b1f8b49/3ffa57d6cf99a38d.png"
              alt=""
              srcset=""
            />
          </div>
          <div style={{ flex: 1, width: 0 }}>{renderActivityNameAndTag(activityInfo)}</div>
        </div>
        <div className={`${prefixCls}-item-opt`}>
          <Button
            ghost
            type="primary"
            shape="round"
            size={'small'}
            style={{ fontSize: 12, backgroundColor: '#ffffff' }}
            onClick={() => delayExecFunc(() => gotoMcActivityDetail(activityId))}
            className={mode === 'special' ? 'btn' : ''}
          >
            立即报名
          </Button>
        </div>
      </div>
    );
  };

  // 资源位活动
  const renderOpenSeckillActivityItem = (activityInfo) => {
    const { resourceId, channelId, activityId, resourcePic, tibaoActivityId } = activityInfo;
    // 开放报名报名页面
    const gotoOpenSeckillApplyPage = async () => {
      logUpload(activityId);
      if (isGoNewRoomList) {
        const detailRes = await activityApis.genericActivityDetailV2({ activityId: tibaoActivityId });
        if (detailRes?.data?.openSeckill === 1) {
          goto(
            `/platform-marketing/resource-detail/apply-roomList?channelId=${channelId}&resourceId=${resourceId}&activityId=${tibaoActivityId}&id=${tibaoActivityId}`,
            'newTab'
          );
          return;
        }
      }

      const newUrl = `/platform-marketing/resource-detail/material-collection/openArea/roomlist?channelId=${channelId}&resourceId=${resourceId}&activityId=${tibaoActivityId}&entry=1&hideTab=1&id=${tibaoActivityId}`;
      window.open(newUrl);
    };

    // 立即报名
    const gotoApplyPage = gotoOpenSeckillApplyPage;
    const buttonElement = (
      <Button
        ghost
        type="primary"
        shape="round"
        size={'small'}
        style={{ fontSize: 12, backgroundColor: '#ffffff' }}
        onClick={() => delayExecFunc(gotoApplyPage)}
        className={mode === 'special' && 'btn'}
      >
        立即报名
      </Button>
    );

    return (
      <div className={`${prefixCls}-item ${mode}`}>
        <div className={`${prefixCls}-item-content`} style={{ alignItems: mode === 'special' ? 'flex-end' : 'center' }}>
          <div className={`${prefixCls}-item-content-left`}>
            <div className="img-wrapper">
              <img
                src={
                  resourcePic ||
                  'https://img14.360buyimg.com/img/jfs/t1/98103/32/38106/2739/6556cfacF8b1f8b49/3ffa57d6cf99a38d.png'
                }
                alt=""
                srcset=""
              />
            </div>
            <div style={{ flex: 1, width: 0 }}>{renderActivityNameAndTag(activityInfo)}</div>
            {/* <div className={`${prefixCls}-item-opt-data`}>{renderApplyElement()}</div> */}
          </div>
          {buttonElement}
        </div>
        {mode === 'special' && <Divider style={{ margin: '12px 0' }} />}
        <div className={`${prefixCls}-item-footer`}>{renderOpenSeckillSkuInfo(activityInfo)}</div>
      </div>
    );
  };

  const renderUmRecommendActivityItem = (activityInfo) => {
    const { ext, unitedShortNumber } = activityInfo;

    return (
      // 京麦10暂时保留单列展示
      <div className={`${prefixCls}-item ${mode}`}>
        <div className={`${prefixCls}-item-content-left`}>
          <div className="img-wrapper">
            <img
              src="https://img14.360buyimg.com/img/jfs/t1/98103/32/38106/2739/6556cfacF8b1f8b49/3ffa57d6cf99a38d.png"
              alt=""
            />
          </div>
          <div style={{ flex: 1, width: 0 }}>{renderActivityNameAndTag(activityInfo)}</div>
        </div>
        <div className={`${prefixCls}-item-opt`}>
          <Button
            ghost
            type="primary"
            shape="round"
            size={'small'}
            style={{ fontSize: 12, backgroundColor: '#ffffff' }}
            onClick={() => delayExecFunc(() => gotoUMActivityDetail(unitedShortNumber))}
          >
            立即报名
          </Button>
        </div>
      </div>
    );
  };

  const renderRecommendActivityItem = (activityInfo) => {
    const activityItemElementMap = {
      1: renderMcActivityItem(activityInfo),
      3: renderOpenSeckillActivityItem(activityInfo),
      2: renderUmRecommendActivityItem(activityInfo),
      // 4: renderUmRecommendActivityItem(activityInfo),
    };
    return activityItemElementMap[activityInfo.activityType];
  };

  return (
    <div className={prefixCls}>
      {loading && (
        <div className={`${prefixCls}-loading`}>
          <Spin />
        </div>
      )}
      {!loading && !recommendActivityList.length && (
        <div className={`${prefixCls}-empty`}>
          <Empty
            // image="https://img13.360buyimg.com/img/jfs/t1/184937/21/40274/4379/6551df79Fe49e1a5d/46817c2a76820f6a.png"
            description={
              <span style={{ color: 'rgba(0, 0, 0, 0.45)', marginTop: 20, fontSize: 12 }}>暂无相关活动</span>
            }
          />
        </div>
      )}
      {!!recommendActivityList.length && (
        <div className={`${prefixCls}-list`}>
          {recommendActivityList.map((item) => (
            <React.Fragment key={item.activityId}>{renderRecommendActivityItem(item)}</React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default HighTrafficActivity;
